import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import NLink from '@src/components/NLink';
import BtnArrow from '@src/components/BtnArrow';

import usePaging from './hooks';
import css from './style.module.scss';
import EllipsisBtn from '../EllipsisBtn';

const Paging = (props) => {
	const {
		description,
		currentPage,
		totalPages,
		onPageSwitchClick,
		baseHref,
		isShallow,
		maxEllipsisLines,
		isNoBtns,
	} = props;

	const { commonLinkProps, getOnLinkClick, buildPagingHref, pages } =
		usePaging({
			currentPage,
			totalPages,
			isShallow,
			baseHref,
			onPageSwitchClick,
		});

	return (
		<div className={cn(css.block)}>
			{description && (
				<div
					className={css.desc}
					// eslint-disable-next-line
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			)}
			<div className={css.pages}>
				{pages.map((page, i) => {
					if (page === 'ELLIPSIS') {
						const start = pages[i - 1] + 1;
						const end = Math.min(
							pages[i + 1] - 1,
							pages[i - 1] + maxEllipsisLines,
						);

						return (
							<EllipsisBtn
								// eslint-disable-next-line react/no-array-index-key
								key={`${page}_${i}`}
								start={start}
								end={end}
								buildPagingHref={buildPagingHref}
								getOnLinkClick={getOnLinkClick}
							/>
						);
					}

					return (
						<NLink
							key={page}
							href={
								page === currentPage
									? null
									: buildPagingHref(page)
							}
							{...commonLinkProps}
						>
							<a
								onClick={getOnLinkClick(page)}
								className={cn(css.page, {
									[css.page_disabled]: page === currentPage,
								})}
							>
								<span className={css.pageText}>
									{page.toString()}
								</span>
							</a>
						</NLink>
					);
				})}
			</div>
			{!isNoBtns && (
				<div className={css.buttons}>
					<NLink
						href={
							currentPage <= 1
								? null
								: buildPagingHref(currentPage - 1)
						}
						onClick={getOnLinkClick(currentPage - 1)}
						{...commonLinkProps}
					>
						<a className={css.btn}>
							<BtnArrow
								disabled={currentPage <= 1}
								type="large"
							/>
						</a>
					</NLink>
					<NLink
						onClick={getOnLinkClick(currentPage + 1)}
						href={
							currentPage >= totalPages
								? null
								: buildPagingHref(currentPage + 1)
						}
						{...commonLinkProps}
					>
						<a className={css.btn}>
							<BtnArrow
								disabled={currentPage >= totalPages}
								type="large"
								direction="right"
							/>
						</a>
					</NLink>
				</div>
			)}
		</div>
	);
};

Paging.propTypes = {
	description: PropTypes.string,
	totalPages: PropTypes.number,
	onPageSwitchClick: PropTypes.func,
	currentPage: PropTypes.number,
	baseHref: PropTypes.string,
	isShallow: PropTypes.bool,
	morePagesLabel: PropTypes.string,
	maxEllipsisLines: PropTypes.number,
	isNoBtns: PropTypes.bool,
};

Paging.defaultProps = {
	description: undefined,
	totalPages: 1,
	onPageSwitchClick: undefined,
	currentPage: 1,
	baseHref: undefined,
	isShallow: false,
	morePagesLabel: undefined,
	maxEllipsisLines: 10,
	isNoBtns: undefined,
};

export default Paging;
